import { useContext } from "react"

import { MapStateContext, MapDispatchContext, MapState, MapDispatch } from "./MapContext.context"

export const useMapStateContext = (): MapState => {
    const context = useContext(MapStateContext)
    if (context === undefined) {
        throw new Error("useMapStateContext must be used within a MapContextProvider")
    }
    return context
}

export const useMapDispatchContext = (): MapDispatch => {
    const context = useContext(MapDispatchContext)
    if (context === undefined) {
        throw new Error("useMapDispatchContext must be used within a MapContextProvider")
    }
    return context
}

export const useMapContext = (): [MapState, MapDispatch] => {
    return [useMapStateContext(), useMapDispatchContext()]
}
